module.exports = __webpack_public_path__ + "static/media/blog-img5.06c37b22.jpg";